import Vue from 'vue'

import './plugins/axios'
import { loadcca_config } from './plugins/cca-config'
import App from './App.vue'
import store from './store'
import router from './router'
import { BootstrapVue, IconsPlugin, TablePlugin, ProgressPlugin, DropdownPlugin } from 'bootstrap-vue'
import Toasted from 'vue-toasted';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import 'vue-multiselect/dist/vue-multiselect.min.css';
import "./styles/scss/style.scss";
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { ValidationProvider } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import Multiselect from 'vue-multiselect';
import { extend } from 'vee-validate';
import { required, numeric, max_value, min_value, email } from 'vee-validate/dist/rules';
// import { closeModal } from '@/function/function.js';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import VueMoment from 'vue-moment';
import VueDndZone from 'vue-dnd-zone'
import 'vue-dnd-zone/vue-dnd-zone.css'

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

import { utilMixins } from './utils/utils-mixins'
//extend('email', email);
import Vue2Editor from "vue2-editor";

Vue.directive('scroll', {
    inserted: function (el, binding) {
      let f = function (evt) {
        if (binding.value(evt, el)) {
          window.removeEventListener('scroll', f)
        }
      }
      window.addEventListener('scroll', f)
    }
  })


Vue.mixin(utilMixins);
Vue.use(VueMoment);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(TablePlugin);
Vue.use(ProgressPlugin);
Vue.use(DropdownPlugin);
Vue.use(Toasted)
Vue.use(VueTelInput);
// Vue.use(closeModal);
Vue.use(VueDndZone)
Vue.use(VueSlickCarousel);
Vue.use(Vue2Editor);

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('multiselect', Multiselect);

extend('email', {
    ...email,
    message: 'L\'e-mail saisi est invalide !'
});
// Override the default message.
extend('required', {
    ...required,
    message: 'Ce champ est obligatoire !'
});

extend('numeric', {
    ...numeric,
    message: 'Ce champ est un nombre'
});

extend('max_value', {
    ...max_value,
    message: 'Produit en rupture de stock !'
});
extend('min_value', {
    ...min_value,
    message: 'Valeur superieur'
});
import '@/styles/scss/field-focus.scss';
import '@/styles/scss/contrast-tokens.scss';
import '@/styles/scss/modal-actions.scss';
import '@/styles/scss/search-fields.scss';

Vue.config.productionTip = false

loadcca_config().finally(() => {
    new Vue({
        NProgress,
        store,
        router,
        render: h => h(App),
    }).$mount('#app')
})
